/* Berkeley Life · The Nitric Oxide Course · offer page
   ---------------------------------------------------------------
   ES5, no dependencies, same reasoning as app.js next door.

   THE NO-JS CONTRACT. Every state on this page is CSS off a hidden
   radio. With this file deleted the plan cards still switch, the
   Supplement Facts panel still opens, the FAQ still opens, the kit
   still checks out through its cart permalink, and the subscription
   button falls through to the PDP. What is lost is the frequency
   figures updating, the handoff line, and the one-click subscription.
   Nothing is left half-built. */

(function () {
  'use strict';

  var $ = function (id) { return document.getElementById(id); };

  /* Stage labels, in the order the course's radio values use. Kept in
     step with STAGES in app.js by hand, because the two pages do not
     share a file. If a stage is ever added or reworded there, it is
     reworded here. */
  var STAGE_LABELS = [
    'premenopausal',
    'early perimenopausal',
    'late perimenopausal',
    'early postmenopausal',
    'late postmenopausal'
  ];

  var qs = new URLSearchParams(window.location.search);

  /* ---------- 1 · the handoff ----------
     Her answer, carried across the page boundary.

     THE GUARD TRAVELS WITH THE NUMBER, and it is not decoration. The
     course's result screen says in as many words that the figure is a
     published average and not a reading of her body. Naming her stage
     again on a page with a price on it, without that line, would be
     personalising a population average straight into a purchase. That
     is the shape a substantiation challenge takes. If this copy is
     ever rewritten, the second sentence survives. */
  (function () {
    var raw = qs.get('stage');
    if (raw === null) return;
    var i = parseInt(raw, 10);
    if (isNaN(i) || i < 0 || i >= STAGE_LABELS.length) return;
    var body = $('handoffBody');
    if (!body) return;
    body.innerHTML = 'You came here from the <strong>' + STAGE_LABELS[i] +
      '</strong> point on the curve. That figure is a published average ' +
      'for the stage and not a reading of your body. The strips are what ' +
      'give you your own.';
  })();

  /* Section 2 was the back link, which carried her query string across
     to the course so that page could still see where she came from.
     Removed with the link itself on 13 Aug. If a back link ever
     returns, it needs that behaviour again, because the browser's own
     Back rebuilds the course at its cover and her answers live in
     memory. */

  /* ---------- 3 · delivery frequency ----------
     Copies the chosen option's data-* onto the price, the billing line
     and the two contents rows, swaps the product shot for one whose
     label prints the matching count, and stamps the variant and
     selling plan onto BOTH subscription buttons.

     BOTH, and that is the one place this differs from women_lp's
     version. There the subscription posts from exactly one button.
     Here the sticky bar carries a live copy of it, so a stamp that
     reached only the inline one would leave the bar subscribing to
     three months no matter what the select said. */
  var subCtas = document.querySelectorAll('.cta--sub');

  (function () {
    var sel = $('bl-freq');
    if (!sel) return;

    var out = {
      price: $('bl-sub-price'),
      billed: $('bl-sub-billed'),
      caps: $('bl-sub-caps'),
      strips: $('bl-sub-strips')
    };
    var img = $('bl-sub-img');
    var base = sel.getAttribute('data-href');

    function apply() {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;

      Object.keys(out).forEach(function (k) {
        var v = opt.getAttribute('data-' + k);
        if (out[k] && v) out[k].textContent = v;
      });

      for (var i = 0; i < subCtas.length; i++) {
        // The href is the no-JS fallback and stays the PDP. The data-*
        // pair is what addSubscription() actually posts.
        if (base) subCtas[i].href = base + '?freq=' + opt.value;
        subCtas[i].setAttribute('data-variant', opt.getAttribute('data-variant') || '');
        subCtas[i].setAttribute('data-selling-plan', opt.getAttribute('data-selling-plan') || '');
      }

      // The shot has to match the count printed on the label.
      var src = opt.getAttribute('data-img');
      if (img && src && img.getAttribute('src') !== src) {
        img.src = src;
        img.alt = opt.getAttribute('data-alt') || '';
      }
    }

    sel.addEventListener('change', apply);
    apply();
  })();

  /* ---------- 3b · reviews, five at a time ----------
     Progressive enhancement, same contract as everything else here.
     The markup ships every review visible and the button hidden, so
     with this file deleted she gets all 35 and no control. This only
     ever REMOVES content and then hands back a way to get it again.

     Five per tap. The button lives after the list, so revealing a
     batch pushes it down under the newest review rather than
     collapsing the stack. She never loses her place. It removes itself
     when the list runs out, because a dead control that still looks
     live is worse than none.

     The FTC note waits with them and reappears with the last batch, so
     the button is the only thing under the reviews until there is
     nothing left to reveal. */
  (function () {
    var list = $('bl-more-reviews');
    var btn = $('bl-more-btn');
    var note = $('bl-reviews-note');
    if (!list || !btn) return;

    var STEP = 5;
    var items = [];
    for (var n = 0; n < list.children.length; n++) items.push(list.children[n]);

    var shown = 0;
    for (var h = 0; h < items.length; h++) items[h].hidden = true;
    btn.hidden = false;
    if (note) note.hidden = true;

    btn.addEventListener('click', function () {
      var firstNew = items[shown];
      shown = Math.min(shown + STEP, items.length);
      for (var i = 0; i < items.length; i++) items[i].hidden = i >= shown;

      /* Focus the first review of the new batch rather than leaving it
         on a button that just moved down the page. -1 keeps it out of
         the tab order; screen readers still land on the new content
         instead of announcing nothing. */
      if (firstNew) {
        firstNew.setAttribute('tabindex', '-1');
        firstNew.focus({ preventScroll: true });
      }

      if (shown >= items.length) {
        btn.hidden = true;
        if (note) note.hidden = false;
      }
      schedule();
    });
  })();

  /* ---------- 3c · the UGC reels ----------
     The markup ships native controls and no autoplay, which is the
     no-JS state, a paused video she can start herself. Here we take
     over, because a scrub bar and an overflow menu are the wrong
     vocabulary for a testimonial.

     Playback is muted, looping and only while on screen. Unmuting one
     mutes the others, because two testimonials talking over each other
     is nobody's idea of proof.

     MUTED IS NOT A PREFERENCE, it is the only way autoplay is allowed
     at all. Every mobile browser blocks an unmuted autoplay, and every
     play() here is caught, so a browser that refuses simply leaves the
     poster frame up and her own tap still works. */
  (function () {
    var items = document.querySelectorAll('.reels__item');
    if (!items.length) return;

    var videos = [];
    Array.prototype.forEach.call(items, function (item) {
      var v = item.querySelector('.reels__video');
      if (!v) return;
      var muteBtn = item.querySelector('[data-reel-mute]');
      var playBtn = item.querySelector('[data-reel-play]');
      videos.push(v);

      v.removeAttribute('controls');
      v.muted = true;
      v.playsInline = true;

      if (muteBtn) {
        muteBtn.addEventListener('click', function () {
          var unmuting = v.muted;
          if (unmuting) {
            videos.forEach(function (other) {
              if (other === v) return;
              other.muted = true;
              var b = other.parentNode.querySelector('[data-reel-mute]');
              if (b) { b.classList.remove('is-on'); b.setAttribute('aria-label', 'Unmute video'); }
            });
          }
          v.muted = !unmuting;
          muteBtn.classList.toggle('is-on', unmuting);
          muteBtn.setAttribute('aria-label', unmuting ? 'Mute video' : 'Unmute video');
          if (unmuting && v.paused) v.play().catch(function () {});
        });
      }

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (v.paused) { v.play().catch(function () {}); } else { v.pause(); }
        });
        v.addEventListener('play', function () {
          playBtn.classList.remove('is-paused');
          playBtn.setAttribute('aria-label', 'Pause video');
        });
        v.addEventListener('pause', function () {
          playBtn.classList.add('is-paused');
          playBtn.setAttribute('aria-label', 'Play video');
        });
      }
    });

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }

    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          v.play().catch(function () {});
        } else {
          v.pause();
          v.muted = true;
          var b = v.parentNode.querySelector('[data-reel-mute]');
          if (b) { b.classList.remove('is-on'); b.setAttribute('aria-label', 'Unmute video'); }
        }
      });
    }, { threshold: 0.55 });
    videos.forEach(function (v) { rio.observe(v); });
  })();

  /* ---------- 4 · reporting ---------- */
  function track(name, data) {
    var payload = { event: name, quiz_id: 'women-no-course' };
    var k;
    for (k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
    try {
      if (typeof window.clarity === 'function') {
        for (k in data) if (Object.prototype.hasOwnProperty.call(data, k)) {
          window.clarity('set', k, String(data[k]));
        }
      }
    } catch (e) {}
  }

  track('offer_view', {
    quiz_via: qs.get('via') || 'direct',
    quiz_stage: qs.get('stage') === null ? '' : qs.get('stage'),
    quiz_score: qs.get('score') === null ? '' : qs.get('score')
  });

  /* ---------- 5 · subscription add-to-cart ----------
     THE SUBSCRIPTION MUST GO THROUGH /cart/add.js WITH ITS
     selling_plan ID. A plain cart permalink silently drops the selling
     plan and charges the one-time price on every bottle, so do not
     simplify this back to an href. This is the single reason the offer
     could not be ported as static markup.

     THE CART ATTRIBUTE IS THE FUNNEL NAME AND NOTHING ELSE.
     `_lp: no-course` distinguishes this page's orders from
     women_lp's `women-curve`, which is what any checkout rule needs to
     key off. The underscore is Shopify's convention for a private
     attribute, so it stays off the order confirmation and the packing
     slip and the customer never sees it.

     HER STAGE IS NOT IN HERE, deliberately. It rides in the URL
     between the two pages because Clarity needs it to read the funnel,
     and it stops at the cart. A menopause stage on an order record is
     health data attached to a name and an address, which is a
     different thing from a segment on an anonymous session. Do not add
     it to improve attribution. */
  function addSubscription(e) {
    var link = e.currentTarget;
    var variant = link.getAttribute('data-variant');
    var plan = link.getAttribute('data-selling-plan');
    if (!variant || !plan) return; // fall through to the href

    e.preventDefault();
    var original = link.textContent;
    link.textContent = 'Adding…';
    track('checkout_click', { quiz_plan: 'subscription' });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        items: [{ id: Number(variant), quantity: 1, selling_plan: Number(plan) }],
        attributes: { '_lp': 'no-course' }
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add failed: ' + r.status);
        window.location.href = '/checkout';
      })
      .catch(function () {
        // Never strand the click. Send her to the PDP instead.
        link.textContent = original;
        window.location.href = link.getAttribute('href');
      });
  }

  for (var i = 0; i < subCtas.length; i++) {
    subCtas[i].addEventListener('click', addSubscription);
  }

  var kitCtas = document.querySelectorAll('.cta--kit');
  for (var j = 0; j < kitCtas.length; j++) {
    kitCtas[j].addEventListener('click', function () {
      track('checkout_click', { quiz_plan: 'kit' });
    });
  }

  /* ---------- 6 · the sticky checkout ----------
     Up only once she has left the top of the page AND the inline
     button is off screen. Both conditions, because a checkout bar
     sliding up over an offer she has not scrolled to yet is pushy, and
     one that stays down while the only button is a screen away is
     useless.

     WHICH inline button is measured depends on the plan she has
     selected, so the one that is actually displayed is found each time
     rather than assumed. offsetParent is null for a display:none
     element, which is the cheapest way to ask.

     The bar is a TRIGGER-driven measurement, not an observer verdict.
     An element below the viewport and an element scrolled off the top
     give an IntersectionObserver the same answer, and here the second
     case is the one where the bar genuinely should be up. */
  var sticky = $('blSticky');
  var pending = false;

  function liveInlineCta() {
    var kit = $('bl-cta-kit');
    var sub = $('bl-cta-sub');
    if (kit && kit.offsetParent !== null) return kit;
    if (sub && sub.offsetParent !== null) return sub;
    return null;
  }

  function measure() {
    pending = false;
    if (!sticky) return;
    var cta = liveInlineCta();
    if (!cta) { sticky.className = 'stickybar'; return; }
    var r = cta.getBoundingClientRect();
    var offScreen = r.bottom < 0 || r.top > window.innerHeight;
    sticky.className = (window.pageYOffset > 240 && offScreen)
      ? 'stickybar is-up' : 'stickybar';
  }

  /* THE HIDDEN-TAB BRANCH IS A BUG FIX, NOT A MICRO-OPTIMISATION, and
     the failure it prevents is permanent rather than momentary.

     requestAnimationFrame does not fire while the document is hidden.
     Without the branch, a scroll that lands as she switches apps sets
     `pending` true and queues a frame that never arrives, so `pending`
     is still true when she comes back. Every later scroll then returns
     at the guard and the bar is dead for the rest of the session.
     Switching apps mid-scroll is ordinary phone behaviour, so this is
     a thing that happens rather than a thing that could.

     Measuring synchronously when hidden is free. Nothing is painting,
     so there is no frame to coalesce with. */
  function schedule() {
    if (pending) return;
    pending = true;
    if (document.hidden) { measure(); return; }
    requestAnimationFrame(measure);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  // Switching plans changes which button is measured and moves the
  // page, so the radios have to re-run this too.
  document.addEventListener('change', schedule);
  measure();
})();
